<template>
    <form @submit.prevent="handleSubmit">
        <div class="mb-3">
            <!-- Input de búsqueda -->
            <label for="search-user" class="form-label">Buscar colaborador para agregar:</label>
            <input type="text" id="search-user" class="form-control" v-model="searchText" @input="searchUsers"
                placeholder="Ingrese Nombre...">

            <!-- Lista de sugerencias -->
            <ul v-if="filteredUsers.length" class="list-group mt-2">
                <li v-for="user in filteredUsers" :key="user.user_id"
                    class="list-group-item d-flex justify-content-between align-items-center" @click="addUser(user)"
                    style="cursor: pointer;">
                    {{ user.name }} {{ user.last_name }}
                    <button class="btn btn-sm btn-warning" style="margin-bottom: 0%;">+ Agregar</button>
                </li>
            </ul>

            <!-- Vista previa de colaboradores seleccionados -->
            <div v-if="selectedUsers.length" class="mt-4">
                <h5>Colaboradores seleccionados:</h5>
                <ul class="list-group">
                    <li v-for="user in selectedUsers" :key="user.user_id"
                        class="list-group-item d-flex justify-content-between align-items-center">
                        {{ user.name }} {{ user.last_name }}
                        <button class="btn btn-sm btn-danger" style="margin-bottom: 0%;"
                            @click="removeUser(user)">Cancelar</button>
                    </li>
                </ul>
            </div>
        </div>
        <div class="mb-3 table-responsive">
            <table id="authUsersTable" class="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th class="d-flex justify-content-center">Colaboradores</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="user in auth_users" :key="user.user_id">
                        <td class="d-flex justify-content-center align-items-center">
                            <span>{{ user.name }} {{ user.last_name }}</span>
                            <button type="button" class="btn btn-danger btn-sm ms-4 mb-0"
                                :data-user-id="user.user_id">Eliminar</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md-12 mt-4">
            <button type="submit" class="btn btn-warning w-100">Guardar</button>
        </div>
    </form>
</template>

<script setup>
import { onMounted, ref, nextTick } from "vue";
import { DataTable } from 'simple-datatables'; // Importa Simple-DataTables
import axios from 'axios';

const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

const searchText = ref(""); // Valor del input de búsqueda
const filteredUsers = ref([]); // Lista de usuarios filtrados por búsqueda
const selectedUsers = ref([]); // Lista de colaboradores seleccionados

// Recibir los datos pasados por el modal
const props = defineProps({
    selectedData: Object,
});

const auth_id = props.selectedData.user_id

const auth_users = ref([])

// Función para buscar colaboradores desde una petición POST
const searchUsers = async () => {
    if (searchText.value.length < 2) {
        filteredUsers.value = [];
        return;
    }

    try {
        const response = await axios.post(`${API_BASE_URL}/search-users-to-auth`,
            { search_text: searchText.value, auth_id: auth_id },
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        );
        filteredUsers.value = response.data;
    } catch (error) {
        console.error("Error al buscar usuarios:", error);
    }
};

// Agregar colaborador a la lista seleccionada
const addUser = (user) => {
    if (!selectedUsers.value.some(u => u.user_id === user.user_id)) {
        selectedUsers.value.push(user);
    }
    searchText.value = ""; // Limpiar input
    filteredUsers.value = []; // Ocultar la lista de sugerencias
};

// Remover colaborador de la lista seleccionada
const removeUser = (user) => {
    selectedUsers.value = selectedUsers.value.filter(u => u.user_id !== user.user_id);
};

const addEventListeners = async () => {
    const table = document.getElementById('authUsersTable');
    table.addEventListener('click', (event) => {
        if (event.target.tagName === 'BUTTON') {
            const user_id = parseInt(event.target.getAttribute('data-user-id'), 10);
            if (confirm('¿Estás segur@ de que las horas de este colaborador ya no sean autorizadas por este usuario?')) {
                removeUserFromAuth(user_id)
            }
        }
    });
}

const removeUserFromAuth = async (userId) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/remove-user-from-auth`,
            {
                user_id: userId,
                auth_id: auth_id,
            },
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        );
        if (response.status === 200) {
            alert("Usuario removido del autorizador");
            window.location.reload();
        }
    } catch (error) {
        console.error("Error al remover el usuario:", error);
        alert("Ocurrió un error al remover el usuario.");
    }
}


const fetchAuthUsers = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/get-users-by-auth`, { auth_id: auth_id }, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        auth_users.value = response.data;
    } catch (error) {
        console.error('Error al obtener los datos de clientes:', error);
    }
}

const handleSubmit = async () => {
    if (selectedUsers.value.length === 0) {
        alert("Debes agregar al menos un colaborador antes de guardar.");
        return; // Detiene la ejecución si no hay usuarios seleccionados
    }
    const selectedUsersIds = selectedUsers.value.map(user => ({ user_id: user.user_id })); // Extrae solo los user_id
    try {
        const response = await axios.post(`${API_BASE_URL}/add-users-to-auth`,
            {
                auth_id: auth_id,
                selected_users: selectedUsersIds  // Enviamos solo los IDs
            },
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        );
        if (response.status === 200) {
            alert("Usuario(s) Agregado(s)");
            selectedUsers.value = []; // Limpia la lista después de agregar
            window.location.reload();
        }
    } catch (error) {
        console.error("Error al agregar usuarios:", error);
        alert("Ocurrió un error al agregar usuarios.");
    }
};



const initializeDataTable = () => {
    nextTick(() => {
        new DataTable('#authUsersTable', {
            searchable: true,
            perPage: 5,
            perPageSelect: [5, 10],
            labels: {
                placeholder: 'Buscar...',
                perPage: 'por página',
                noRows: 'No se encontraron registros',
                info: 'Mostrando {start} a {end} de {rows}',
            },
        });
    });
};

// Inicializa el DataTable después de obtener los datos
onMounted(async () => {
    await fetchAuthUsers()
    initializeDataTable()
    addEventListeners()
});

</script>